import { Color } from './../framework/geom/Color';
import { MathUtil } from './../framework/utils/MathUtil';
import { app } from './../app.world';
import { LevelInfo } from './../data/LevelInfo';
import { UserRecord, LevelRecord, userRecord } from './../data/UserRecord';
import { GameHost } from './GameHost';
import { Popup } from './Popup';
import { BaseScreen } from './BaseScreen';
import { FW } from './../framework/Framework';

export class LevelSelectScreen extends BaseScreen {

    private _sprite: GAF.GAFMovieClip;

    constructor(private config: { code: string }) {
        super();

        this._sprite = FW.gafManager.createMovieClip('worlds', 'lib_level_selection');
        this._sprite.gotoAndStop(this.config.code);
        FW.root.addChild(this._sprite);

        let field: GAF.GAFTextField = this._sprite['title'];
        //field.set_text(this.config.code);
        field.set_text('');

        this.refreshLevelClips();

        userRecord.on(UserRecord.EVENT.LEVEL_RECORD_CHANGE, () => {
            this.refreshLevelClips();
        });

        this.setupButton(this._sprite['buttonBack'], () => {
            app.showGameCover();
        }, 'Back');
    }

    private refreshLevelClips(): void {
        for (var lv: number = 0; lv <= 10; ++lv) {
            this.setupLevelClip(lv);
        }
    }

    public get sprite(): GAF.GAFMovieClip {
        return this._sprite;
    }

    private setupLevelClip(lvIndex: number): void {
        let clipname: string = lvIndex == 0 ? 'levelchallenge' : ('level' + lvIndex);
        let info: LevelInfo = LevelInfo.getLevel(this.config.code, lvIndex);
        let level: string = info.level;
        let clip: GAF.GAFMovieClip = this._sprite[clipname];
        let timeName: string = 'time_' + this.config.code;
        let levelName: string = 'level_' + this.config.code;

        if (userRecord.isLevelLocked(level)) {
            levelName += '_locked';
            clip.gotoAndStop(this.config.code + '_locked');
            let color: Color = new Color(0);
            let filter = new PIXI.filters.ColorMatrixFilter();
            filter.matrix = color.tintMatrix(0.5);
            clip.filters = [filter];
        } else {
            clip.gotoAndStop(this.config.code);
            clip.filters = [];
        }

        if (clip.name.indexOf('inited') == -1) {
            FW.gafManager.removeLocalTransform(clip[levelName]);
            clip[levelName].x -= 7;
            clip[levelName].y += 7;
            clip[levelName].set_text('' + lvIndex);
        }
        if (info.isChallenge) {
            clip[levelName].visible = false;
            clip['challenge_icon'].visible = true;
        } else {
            clip[levelName].visible = true;
            clip['challenge_icon'].visible = false;
        }

        if (userRecord.isLevelLocked(level)) {

        } else {

            if (clip.name.indexOf('inited') == -1) {
                FW.gafManager.removeLocalTransform(clip[timeName]);
                if(lvIndex == 0) {
                    clip[timeName].x -= 42;
                    clip[timeName].y += 15;   
                } else {
                    clip[timeName].x -= 7;
                    clip[timeName].y += 7;    
                }
                this.setupButton(clip['buttonPlay'], () => this.showLevel(level), 'Play');
            }

            clip.name += 'inited';
            let record: LevelRecord = userRecord.getLevelRecord(level);
            let stars: GAF.GAFMovieClip = clip['stars'];
            if (record && record.stars) {
                stars.gotoAndStop(record.stars + 1);
            } else {
                stars.gotoAndStop(1);
            }

            if (record) {
                clip[timeName].set_text(MathUtil.formatTimer(record.time, false));
            } else {
                clip[timeName].set_text(' -:--');
            }
        }
    }

    private showLevel(level: string): void {
        if (level == 'worlds') {
            app.showGameCover();
        } else if (level && LevelInfo.fromString(level)) {
            new Popup().forLevelSelect(level)
                .then(lv => this.playLevel(lv));
        }
    }

    private playLevel(level: string): void {
        if (level) {
            new GameHost(level).execute()
                .then(nextLevel => this.showLevel(nextLevel));
        }
    }
}


// WEBPACK FOOTER //
// ./src/worlds/LevelSelectScreen.ts